import { constants } from '@wsb/guac-widget-core';
import { FILL, FIT, INSET, BLUR, LEGACY_BLUR } from '../../common/constants/headerTreatments';
import { IMAGE, VIDEO, NONE } from '../../common/constants/mediaTypes';
import { COMMON_BUTTON_CONFIG } from '../../common/constants';
import imageToHeaderTreatments from '../../common/utils/imageToHeaderTreatments';

const { colorPackCategories, buttons } = constants;
const { LIGHT, LIGHT_ALT, LIGHT_COLORFUL, DARK, DARK_ALT, DARK_COLORFUL, COLORFUL } =
  constants.paintJobs;

const id = 'layout15';
const imageTreatments = {
  [FILL]: 'none',
  [FIT]: 'none',
  [INSET]: 'category-alt-solid',
  [BLUR]: 'none',
  [LEGACY_BLUR]: 'none'
};
const defaultHeaderTreatment = FILL;
const headerTreatments = imageToHeaderTreatments(imageTreatments);
const headerTreatmentsConfig = {
  defaultHeaderTreatment,
  heroContentItems: ['tagline', 'tagline2', 'cta', 'phone'],
  fillConfig: {
    props: {
      fixedMinHeight: '500px'
    }
  },
  imageTreatments,
  headerTreatments,
  mediaSupport: {
    [NONE]: [defaultHeaderTreatment],
    [IMAGE]: Object.keys(imageTreatments),
    [VIDEO]: [defaultHeaderTreatment]
  }
};
const defaultPaintJob = LIGHT;

export default {
  id,
  name: 'luxe',
  packs: {
    color: '#BA873E',
    font: 'playfair-display'
  },
  packCategories: {
    color: colorPackCategories.NEUTRAL
  },
  headerProperties: {
    alignmentOption: 'center',
    defaultLogoAlign: 'center'
  },
  headerTreatmentsConfig,
  paintJobs: [LIGHT, LIGHT_ALT, LIGHT_COLORFUL, COLORFUL, DARK_COLORFUL, DARK_ALT, DARK],
  defaultPaintJob,
  buttons: {
    primary: {
      fill: buttons.fills.SOLID,
      shape: buttons.shapes.PILL,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    secondary: {
      fill: buttons.fills.SOLID,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    ...COMMON_BUTTON_CONFIG
  },
  defaultNavFamily: 'navFamily3'
};
